import { render, staticRenderFns } from "./CostTemplate.vue?vue&type=template&id=ccc9cdf2&scoped=true&"
import script from "./CostTemplate.vue?vue&type=script&lang=js&"
export * from "./CostTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CostTemplate.vue?vue&type=style&index=0&id=ccc9cdf2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc9cdf2",
  null
  
)

export default component.exports